import {
  CalendarDays,
  CircleCheck,
  CircleX,
  ClipboardCheck,
  ClipboardPenLine,
} from "lucide-react";
import { cn } from "@/shared/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import t from "@/lang/lang";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";

export function FulfillmentStateIcon({
  state,
  className,
  disableTooltip,
}: {
  state: FulfillmentState;
  className?: string;
  disableTooltip?: boolean;
}) {
  if (state === FulfillmentState.Zero) {
    return null;
  }

  const defaultClassName = "size-5";

  return (
    <Tooltip>
      <TooltipTrigger>
        {state === FulfillmentState.Planning && (
          <CalendarDays className={cn(defaultClassName, className)} />
        )}
        {state === FulfillmentState.Execution && (
          <ClipboardPenLine className={cn(defaultClassName, className)} />
        )}
        {state === FulfillmentState.Executed && (
          <ClipboardCheck className={cn(defaultClassName, className)} />
        )}
        {state === FulfillmentState.PartiallyExecuted && (
          <ClipboardCheck
            className={cn(defaultClassName, "text-yellow-500", className)}
          />
        )}
        {state === FulfillmentState.Completed && (
          <CircleCheck className={cn(defaultClassName, className)} />
        )}
        {state === FulfillmentState.Cancelled && (
          <CircleX className={cn(defaultClassName, className)} />
        )}
      </TooltipTrigger>
      <TooltipContent hidden={disableTooltip}>
        <p>{t(state)}</p>
      </TooltipContent>
    </Tooltip>
  );
}
